import { render } from "./Careers.vue?vue&type=template&id=67b7731c"
import script from "./Careers.vue?vue&type=script&lang=js"
export * from "./Careers.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__